import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿En qué formato recibo el sistema?',
    a: 'PDF descargable. Acceso inmediato después del pago. Podés leerlo desde el celular, la tablet o la computadora. También podés imprimir las fichas que querés usar. Cada ficha está diseñada para quedar perfecta en una sola hoja impresa.'
  }, {
    q: '¿Necesito conocimientos de salud o psicología para usarlo?',
    a: 'No. El sistema está diseñado para familias sin ningún conocimiento previo. Cada ficha tiene instrucciones claras para el familiar y la actividad lista para el adulto mayor. No necesitás saber nada de neurología ni de estimulación cognitiva para usarlo correctamente.'
  }, {
    q: '¿Para qué edad está pensado?',
    a: 'Para adultos mayores a partir de los 60 años aproximadamente. Es especialmente útil entre los 65 y los 85 años, que es cuando los olvidos cotidianos empiezan a aparecer con más frecuencia. No es para personas con diagnóstico de demencia avanzada.'
  }, {
    q: '¿Lo puede hacer solo el adulto mayor o necesita ayuda?',
    a: 'La mayoría de las fichas están diseñadas para hacerse de forma independiente. Algunas del Tomo 6 y los bonos familiares están pensadas para hacer en familia. El sistema funciona en ambos modos.'
  }, {
    q: '¿Sirve si los olvidos ya son frecuentes o recién están empezando?',
    a: 'Sirve en los dos casos. Si los olvidos recién empiezan, el sistema actúa como prevención y mantenimiento. Si ya son frecuentes, actúa como recuperación progresiva. Lo importante es empezar.'
  }, {
    q: '¿Qué pasa si no lo usan?',
    a: 'Las fichas están diseñadas para ser simples, entretenidas y no intimidantes. El adulto mayor no siente que está haciendo una terapia sino que está jugando y recordando. La mayoría de las familias que lo compran nos cuenta que el mayor desafío fue convencer al adulto mayor de empezar. Después de las primeras fichas, son ellos los que piden más.'
  }];
  return <section className="py-20 px-4 bg-[#EFE4CC]" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 text-center mb-12" data-id="element-76">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-78" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-orange-200 rounded-xl overflow-hidden shadow-sm" data-id="element-79">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-80">
        <span className="font-bold text-slate-900 pr-4" data-id="element-81">{question}</span>
        <ChevronDown className={`w-5 h-5 text-teal-600 transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-82" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-83">
        <p className="text-slate-600 leading-relaxed" data-id="element-84">{answer}</p>
      </div>
    </div>;
}